import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { api } from '../../utils/electronAPI';
import { ladeEinsatzRegeln } from '../../utils/disposition';

// Gedächtnisregeln für die Plantafel — eigener Schritt, weil neue Regeln erst
// von der KI übersetzt werden und die Tafel darauf nicht warten soll.
export const loadEinsatzRegeln = createAsyncThunk('plantafel/loadRegeln', () => ladeEinsatzRegeln());

export const loadPlantafelData = createAsyncThunk(
    'plantafel/loadData',
    async (_, { rejectWithValue, dispatch }) => {
        dispatch(loadEinsatzRegeln());
        try {
            const [mitarbeiter, fahrzeuge, einsaetze, werkzeuge] = await Promise.all([
                api.getMitarbeiter(),
                api.getFahrzeuge(),
                api.getEinsaetze(),
                api.getWerkzeuge(),
            ]);
            return { mitarbeiter, fahrzeuge, einsaetze, werkzeuge };
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

const plantafelSlice = createSlice({
    name: 'plantafel',
    initialState: {
        mitarbeiter: [],
        fahrzeuge: [],
        einsaetze: [],
        werkzeuge: [],
        regeln: [],
        isLoading: false,
        error: null,
    },
    reducers: {
        addMitarbeiterLocal: (state, action) => { state.mitarbeiter.push(action.payload); },
        updateMitarbeiterLocal: (state, action) => {
            const idx = state.mitarbeiter.findIndex(m => m.id === action.payload.id);
            if (idx !== -1) state.mitarbeiter[idx] = { ...state.mitarbeiter[idx], ...action.payload };
        },
        removeMitarbeiterLocal: (state, action) => {
            state.mitarbeiter = state.mitarbeiter.filter(m => m.id !== action.payload);
        },
        addFahrzeugLocal: (state, action) => { state.fahrzeuge.push(action.payload); },
        updateFahrzeugLocal: (state, action) => {
            const idx = state.fahrzeuge.findIndex(f => f.id === action.payload.id);
            if (idx !== -1) state.fahrzeuge[idx] = { ...state.fahrzeuge[idx], ...action.payload };
        },
        removeFahrzeugLocal: (state, action) => {
            state.fahrzeuge = state.fahrzeuge.filter(f => f.id !== action.payload);
        },
        addEinsatzLocal: (state, action) => { state.einsaetze.push(action.payload); },
        updateEinsatzLocal: (state, action) => {
            const idx = state.einsaetze.findIndex(e => e.id === action.payload.id);
            if (idx !== -1) state.einsaetze[idx] = { ...state.einsaetze[idx], ...action.payload };
        },
        removeEinsatzLocal: (state, action) => {
            state.einsaetze = state.einsaetze.filter(e => e.id !== action.payload);
        },
        addWerkzeugLocal: (state, action) => { state.werkzeuge.push(action.payload); },
        updateWerkzeugLocal: (state, action) => {
            const idx = state.werkzeuge.findIndex(w => w.id === action.payload.id);
            if (idx !== -1) state.werkzeuge[idx] = { ...state.werkzeuge[idx], ...action.payload };
        },
        removeWerkzeugLocal: (state, action) => {
            state.werkzeuge = state.werkzeuge.filter(w => w.id !== action.payload);
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(loadPlantafelData.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(loadPlantafelData.fulfilled, (state, action) => {
                state.mitarbeiter = action.payload.mitarbeiter;
                state.fahrzeuge   = action.payload.fahrzeuge;
                state.einsaetze   = action.payload.einsaetze;
                state.werkzeuge   = action.payload.werkzeuge;
                state.isLoading   = false;
            })
            .addCase(loadPlantafelData.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            })
            .addCase(loadEinsatzRegeln.fulfilled, (state, action) => {
                state.regeln = action.payload || [];
            });
    },
});

export const {
    addMitarbeiterLocal, updateMitarbeiterLocal, removeMitarbeiterLocal,
    addFahrzeugLocal,    updateFahrzeugLocal,    removeFahrzeugLocal,
    addEinsatzLocal,     updateEinsatzLocal,     removeEinsatzLocal,
    addWerkzeugLocal,    updateWerkzeugLocal,    removeWerkzeugLocal,
} = plantafelSlice.actions;

export default plantafelSlice.reducer;
